import { bool, func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
	toggleAllBrandSelectionForFilter,
	toggleMultipleSelectedBrandForFilter,
	toggleSelectedBrandForFilter
} from '@store/actions/trend-research/TrendResearchAction';
import { useSelectedBrands } from '@store/reducers/trend-research/TrendResearchReducer';

import { groupByKey } from '@utils/Util';

const BrandFilterLeftSidePanel = ({ isShowFilter, toggleIsShowFilter, brandList }) => {
	const sortList = [
		{ label: 'A to Z', value: 'A_TO_Z' },
		{ label: 'Price point', value: 'group' },
		{ label: 'Fashion type', value: 'type' }
	];
	const [brands, setBrands] = useState([]);
	const [search, setSearch] = useState('');
	const [sortType, setSortType] = useState(sortList[0].value);
	const selectedBrands = useSelectedBrands();
	const dispatch = useDispatch();

	const handleSearch = (e) => {
		e.preventDefault();
		setSearch(e.target.value);
	};

	useEffect(() => {
		if (search) {
			let filteredList = brandList.filter(
				(brand) => brand.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
			);
			setBrands(filteredList);
		} else {
			setBrands(brandList);
		}
	}, [search, brandList]);

	const toggleBrandSelection = (brandCode) => {
		dispatch(toggleSelectedBrandForFilter({ selectedCode: brandCode }));
	};

	const getSelectedAndUnselectedBrandIds = (brandList) => {
		const existingBrands = [];
		const notExistingBrands = [];

		for (let brand of brandList) {
			if (selectedBrands.includes(brand.code)) {
				existingBrands.push(brand.code);
			} else {
				notExistingBrands.push(brand.code);
			}
		}
		return {
			existingBrands,
			notExistingBrands
		};
	};

	const toggleGroupWiseSelection = (brandList) => {
		const { existingBrands, notExistingBrands } = getSelectedAndUnselectedBrandIds(brandList);
		dispatch(
			toggleMultipleSelectedBrandForFilter({
				selectedCodes: notExistingBrands.length > 0 ? notExistingBrands : existingBrands
			})
		);
	};

	const renderBrands = () => {
		let sortedBrand = brands.sort((a, b) => a.name.localeCompare(b.name));
		let groupedData = groupByKey(sortedBrand, sortType);
		return Object.keys(groupedData).map((key) => {
			let groupedBrands = groupedData[key] || [];
			return groupedBrands?.map((item, idx) => {
				return (
					<React.Fragment key={`brand_${item.code}`}>
						{key !== 'no_key' && idx === 0 && (
							<div className="form-group active">
								<input
									type="checkbox"
									id={`groupedBrands_${key}`}
									name={`groupedBrands_${key}`}
									checked={
										getSelectedAndUnselectedBrandIds(groupedBrands).notExistingBrands
											.length === 0
									}
									onChange={() => toggleGroupWiseSelection(groupedBrands)}
								/>
								<label className="regular-14 gray_dark_05" htmlFor={`groupedBrands_${key}`}>
									<span>
										{key} ({groupedBrands.length})
									</span>
								</label>
							</div>
						)}
						<div className="form-group group-brand-checkbox">
							<input
								type="checkbox"
								id={`brand_${item.code}`}
								name={`brand_${item.code}`}
								checked={selectedBrands.includes(item.code)}
								onChange={() => toggleBrandSelection(item.code)}
							/>
							<label className="regular-14 gray_dark_05" htmlFor={`brand_${item.code}`}>
								<span>{item.name}</span>
							</label>
						</div>
					</React.Fragment>
				);
			});
		});
	};

	const toggleAllBrands = () => {
		if (selectedBrands.length === brandList.length) {
			dispatch(toggleAllBrandSelectionForFilter({ selectedCodes: [] }));
		} else {
			dispatch(toggleAllBrandSelectionForFilter({ selectedCodes: brandList.map((item) => item.code) }));
		}
	};

	return (
		<div className={`brand-sidebar shadow-12dp ${isShowFilter ? 'active' : ''}`}>
			<div className="sidebar-header d-flex justify-content-between align-items-center">
				<p className="regular-14 gray_dark_02">Select Brand</p>
				<span className="cursor-pointer" onClick={toggleIsShowFilter}>
					<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="" />
				</span>
			</div>
			<div className="info-tabs inner-tabs d-flex flex-wrap pb-3">
				<ul className="d-flex flex-wrap">
					{sortList.map((item) => (
						<li
							onClick={() => setSortType(item.value)}
							className={sortType === item.value ? 'active' : ''}
							key={`sort_${item.value}`}
						>
							{item.label}
						</li>
					))}
				</ul>
			</div>
			<div className="form-group size36 m-0 search-filter mb-3">
				<div className="with-icon right-icon">
					<input type="text" placeholder="Search" value={search} onChange={handleSearch} />
					<span className="right-icon cursor-pointer">
						<img src="../icons/search.png" alt="" />
					</span>
				</div>
			</div>
			<div className="custom-chekbox brand-checkbox scroll-y-label">
				<div className="form-group active">
					<input
						type="checkbox"
						id="allBrands"
						name="all_brands"
						checked={selectedBrands.length > 0 && selectedBrands.length === brandList.length}
						onChange={toggleAllBrands}
					/>
					<label className="regular-14 gray_dark_05" htmlFor="allBrands">
						<span>ALL</span>
					</label>
				</div>
				{renderBrands()}
			</div>
		</div>
	);
};

BrandFilterLeftSidePanel.propTypes = {
	isShowFilter: bool.isRequired,
	toggleIsShowFilter: func.isRequired
};

export default BrandFilterLeftSidePanel;
